module.exports = __webpack_public_path__ + "static/img/bg.b305686f.jpeg";